import { ConsentBanner } from '@atlassian/browser-storage-controls/consent-banner';
import { initializeControls } from '@atlassian/browser-storage-controls/controllers/cookie-controls/initialize-controls';
import { isLocal } from '@dev-agents/env';
import { useEffect } from 'react';

export const ConsentBannerComponent = () => {
	const isConsentBannerAnalyticsEnabled = !isLocal();
	const product = 'dev-agents';

	useEffect(() => {
		initializeControls({
			product,
			webStorageEnabled: true,
			analyticsEnabled: isConsentBannerAnalyticsEnabled,
		});
	}, [isConsentBannerAnalyticsEnabled]);

	return <ConsentBanner product={product} analyticsEnabled={isConsentBannerAnalyticsEnabled} />;
};
